import { render, staticRenderFns } from "./ReviewList.vue?vue&type=template&id=4cb3877f&"
import script from "./ReviewList.vue?vue&type=script&lang=js&"
export * from "./ReviewList.vue?vue&type=script&lang=js&"
import style0 from "./ReviewList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports